import { AppEnvConfig } from "@app/types/root-state/appEnvConfig"
import { AnyAppEnvCreator, AppEnvConfigAction } from "./appEnvConfigCreator"

const INITIAL_STATE: AppEnvConfig = {
    version: "",
    buildNumber: -1,
    os: "",
    osVersion: "",
    isProdLogin: "",
    isTestTrumfId: "",
    isTrumfIdEnabled: "",
    isTrumfPayEnabled: "",
    urls: null,
}

export default (state = INITIAL_STATE, action: AnyAppEnvCreator): AppEnvConfig => {
    switch (action.type) {
        case AppEnvConfigAction.SetAppEnvConfigData:
            if (action.payload.version === "legacy") {
                // Do not overwrite version or buildnumber when handling a legacy appconfig:
                return {
                    ...state,
                    version: state.version || action.payload.version,
                    buildNumber: state.buildNumber || action.payload.buildNumber,
                }
            }
            return action.payload
        default:
            return state
    }
}
